import React, { Fragment } from 'react'
import {Col, Form, OverlayTrigger, Tooltip } from 'react-bootstrap'
import Select,{components} from 'react-select'
import FeatherIcons from 'feather-icons-react';


export const SelectInput = ({onChange,selectTitle,options,selectName,onInputChange,inputValue,
  onAdd,required,showPop,value,disable}) => {
  
  return ( 
    <Fragment>
        <div className="mb-3" > 
        <Form.Label className="form-label">{selectTitle} </Form.Label> <br /> 
          <Select
            className="react-select react-select-container"
            classNamePrefix="react-select"
            name={selectName}
            //value={value}
            isSearchable
            onChange={onChange}
            onInputChange= {onInputChange}
            defaultValue= {value}
            inputValue= {inputValue}
            isDisabled= {disable}
            styles={{
              container: (props)=>({...props,border: required&&'1px solid red'})
            }}
            options={options}></Select>
          {/* {showPop&&<OverlayTrigger placement='top'overlay={(props) => (
            <Tooltip {...props}>
              Add New 
            </Tooltip>
          )}
          >
          <FeatherIcons onClick= {onAdd} style={{marginLeft: '3px',cursor: 'pointer'}} icon= "plus-circle"/>
          </OverlayTrigger>} */}
          
        </div>
    </Fragment>
  )
}

export const TextInput = ({textTitle,textName,onChange,required, value, defaultValue}) => {
  return (
    <div className="mb-3">
        <Form.Label className="form-label">{textTitle}</Form.Label> <br />
        <Form.Control value={value} style={{borderColor: required&& 'red'}} 
        required= {required} type="text" onChange={onChange} name={textName} defaultValue= {defaultValue}
        placeholder='Type here...' />
        {required&&<span style={{color: 'red',fontSize: '5px'}} className="help-block">
            <small>
                Please fill this.
            </small>
        </span>}
    </div>
  )
}


export const FileUpload = ({fileTitle,required,onChange,fileName,value}) => {
  return (
    <>
    <div className="mb-3">
        <Form.Label className="form-label">{fileTitle}</Form.Label> <br />
        <Form.Control value={value} name={fileName} onChange={onChange} required= {required} style={{borderColor: required&& 'red'}} type="file" id="example-fileinput" />
        {required&&<span style={{color: 'red',fontSize: '5px'}} className="help-block">
            <small>
                Please fill this.
            </small>
        </span>}
    </div>
    </>
  )
}


export const TextArea = ({AreaTitle,required,onChange,areaName, value}) => {
  return (
    <div className="mb-3">
        <Form.Label className="form-label">{AreaTitle}</Form.Label> <br />
        <Form.Control value={value} name={areaName} onChange={onChange} required= {required} style={{borderColor: required&& 'red'}} as="textarea" rows={2} id="example-textarea" />
        {required&&<span style={{color: 'red',fontSize: '5px'}} className="help-block">
            <small>
                Please fill this.
            </small>
        </span>}
    </div>
  )
}


export const Phone = ({phoneTitle,onChange,phoneName,value,required}) => {
  return (
    <div className="mb-3">
      <Form.Label className="form-label">{phoneTitle}</Form.Label> <br />
      <Form.Control value={value} required= {required} pattern='[0-9]+' onChange={onChange} 
      name= {phoneName} minLength={10} maxLength={10} type='text' placeholder='Phone Number' />
      {required&&<span style={{color: 'red',fontSize: '5px'}} className="help-block">
            <small>
                Please fill this.
            </small>
        </span>}
  </div>
  )
}


export const DateInput = ({required,onChange,dateTitle,dateName,value}) => {
  return (
    <div className="mb-3">
      <Form.Label className="form-label">{dateTitle}</Form.Label> <br />
      <Form.Control value={value} style={{borderColor: required&& 'red'}} required= {required} name= {dateName} onChange={onChange} type='date' placeholder='yyyy-MM-dd' />
      
      {required&&<span style={{color: 'red',fontSize: '5px'}} className="help-block">
            <small>
                Please fill this.
            </small>
        </span>}
    </div>
  )
}


